<script lang="ts">
    import type {MessageVideoNote} from "./Types";
    import type {ChatMessageAttachmentData} from "../../Types";
    import Minithumbnail from "./Minithumbnail.svelte";
    import {authBlobUrl} from "../../Auth";
    import InView from "../InView.svelte";
    export let entity: MessageVideoNote
    export let attachments: ChatMessageAttachmentData[]
</script>
<Minithumbnail entity={entity.video_note.minithumbnail}/><br/>
<div class="alert alert-warning m-0">
    Відео повідомлення тривалістю {entity.video_note.duration} секунд.<br>
    {#if attachments && attachments.length}
        {#each attachments as attachment}
            {#if attachment.telegram_remote_attachment_id == entity.video_note.video.remote.id}
                {#if attachment.status === 'pending'}
                    Запис ще не викачаний
                {:else if attachment.status === 'failed'}
                    Запис викачати не вдалось
                {:else if attachment.status === 'success'}
                    <InView>
                    {#await authBlobUrl('/attachments/'+attachment.id)}
                        <div class="spinner-grow"></div>
                    {:then src}
                        {#if src}
                            <video controls style:width="100%">
                                <track kind="captions" src=""/>
                                <source {src} type="{entity.video_note.video.mime_type}">
                            </video>
                        {:else}
                            Не вдалось завантажити.
                        {/if}
                    {:catch error}
                        Не вдалось завантажити.
                    {/await}
                    </InView>
                {/if}
            {/if}
        {/each}
    {:else}
        Не викачано
    {/if}
</div>
